<template name="component-name">
  <div>

    <div class="slides">
      <slot :current="current">
      </slot>
    </div>

    <span
      class="prev"
      v-show="active > 0"
      @click="move(-1)"
    >

      <i class=""><md-icon class="arrowLeft md-size-2x">keyboard_arrow_left</md-icon></i>
    </span>
    <span
      class="next"
      v-show="active < array.length -1"
      @click="move(1)"
    >
      <i class=""><md-icon class="arrowRight md-size-2x">keyboard_arrow_right</md-icon></i>
    </span>
    <ul class="dots" v-if="array.length > 1">
      <li v-for="(dot, index) in array" :class="{ active: index === active }" @click="jump(index)" :key="index"></li>
    </ul>
  </div>
</template>

<script>
// import media from "./media";
// TODO: MOVE FILE TO SHARED

export default {
  props: ['array'],
  // components: {
  //   media
  // },
  data() {
    return {
      active: 0
    }
  },
  computed: {
    current() {
      return this.array[this.active];
    }
  },
  methods: {
    move(amount) {
      let newIndex = this.active + amount;
      if (newIndex >= this.array.length)
        return this.active = 0;
      else if (newIndex < 0)
        return this.active = this.array.length - 1;
      return this.active = newIndex;
    },
    jump(index) {
      this.active = index
    }
  }
}
</script>

<style lang="scss" scoped>
.slideLanding{
  position: relative;
  width: 100%;
}

$primary: #11999e;

.prev,
.next {
  position: absolute;
  // top: 50%;
  width: 50px;
  height: 50px;
  // border: 2px solid #fff;
  // color: #fff;
  // border-radius: 50%;
  // margin-top: -25px;
  margin-left: 10px;
  cursor: pointer;
  z-index: 2;
  line-height: 48px;
  text-align: center;
  text-indent: -2px;
  transition: all 0.2s cubic-bezier(0.175, 0.885, 0.32, 1.275);

  &:hover {
    // background: #fff;
    color: #fff;
    transform: scale(1.2);
    &.slides{
      pointer-events: none !important;
    }
  }

  &:active {
    transform: translate(0, 3px) scale(1.2);
  }
}

.next {
  right: 0;
  margin-left: auto;
  margin-right: 10px;
  text-indent: 2px;
}

.arrowLeft{
  color: #fff!important;
}

.arrowRight{
  color: #fff!important;
}

.prev:hover .arrowLeft{
  color: #221e21!important;
}

.next:hover .arrowRight{
  color: #221e21!important;
}

.dots {
  position: initial;
  width: 100%;
  text-align: center;
  bottom: 20px;
  padding: 0;

  li {
    width: 6px;
    height: 6px;
    border-radius: 3px;
    background: #fff;
    opacity: 0.2;
    display: inline-block;
    margin: 0 3px;
    cursor: pointer;
    transition: opacity 0.4s ease-in-out,width 0.4s cubic-bezier(0.175, 0.885, 0.32, 1.275);

    &.active {
      width: 22px;
      opacity: 1;
    }
  }
}

.invisible {
  display: none;
}

.slides {
  font-size: 40px;
  display: flex;
  height: 100%;
  align-items: center;
  justify-content: center;
  font-weight: bold;
  text-align: center;

  // @media (min-width: 600px) {
  //   font-size: 50px;
  // }

  // @media (min-width: 900px) {
  //   font-size: 50px;
  // }

  .animated {
    transition: all 400ms;
    position: absolute;
    transform: translate(-50%, -50%);
  }

  .slide-in {
    opacity: 0;
    transform: translate(-40%, -50%);
  }

  .slide-in-active {
    transition-delay: 150ms;
  }

  .slide-out {
    opacity: 1;
  }

  .slide-out-active {
    opacity: 0;
    transform: translate(-60%, -50%);
  }
}

.buttons {
  position: absolute;
  top: 10px;
  left: 10px;
}

button {
  padding: 10px;
  outline: none;
  border: none;
  -webkit-appearance: none;
  background: $primary;
  color: #221e21;
  font-weight: bold;
  font-size: 18px;
  cursor: pointer;

  &:disabled {
    opacity: 0.2;
    cursor: no-drop;
  }
}

// .imgSlides{
//   max-width:100vw;
//   max-height: 85vh;
//   object-fit: contain;
// }

.textSlide{
  font-size: smaller;
  line-height: normal;
}

</style>
